export const isEmpty = obj => !Object.keys(obj || {}).length;
